<template>
  <div ref="controls" class="controls">
    <div class="controls_right">
      <img @click="isShowDanMuFn" width="40px" :src="danMuSrc" alt="">
    </div>
  </div>
</template>

<script>
export default {
  name: "PlayBackControls",
  data() {
    return {
      isShowDanMu: true,
      danMuSrc: require("@/assets/img/cloudClassCenter/danMuOpen.png")
    };
  },

  methods: {
    //是否显示弹幕
    isShowDanMuFn() {
      this.isShowDanMu = !this.isShowDanMu;
      if (this.isShowDanMu) {
        this.danMuSrc = require("@/assets/img/cloudClassCenter/danMuOpen.png");
      } else {
        this.danMuSrc = require("@/assets/img/cloudClassCenter/danMuClose.png");
      }
    }
  },

  watch: {
    isShowDanMu(newVal) {
      this.$emit("isShowDanMu", newVal);
    }
  }
};
</script>

<style lang="less" scoped>
.controls {
  display: flex;

  position: absolute;
  bottom: 0;
  right: 40px;

  padding: 0 11px;

  align-items: center;
  justify-content: space-between;

  .controls_right {
    img {
      cursor: pointer;
    }
  }

  .controls_right {
    display: flex;
    align-items: center;
  }
}
</style>